const SLICES = {
	ACCOUNTS: 'accounts',
	ASSERTIONS: '_assertions',
	RISKS: '_risks',
	JOURNALSOURCE: 'journalSource',
	TRIAL_BALANCE: 'trialBalances',
	ESTIMATES: 'estimates',
	STENTITIES: 'stEntities'
};

export default SLICES;
